import { ToolkitProperty, isDefined, isFunction } from '@aloft/toolkit-shared';
import { SortingFn as ReactTableSortingFn } from '@tanstack/react-table';

import { getPinnedRowSortingOrder } from './getPinnedRowSortingOrder';
import { TPTableSelector, TPTableSortBy } from './types';

export function makeSortingProps<T, U>(
  sortBy: TPTableSortBy<U> | undefined,
  selector: TPTableSelector<T, U>,
  shouldPinFirstRow: boolean | number,
  isSortedDesc: boolean,
  getCompareValues: (rowA: T, rowB: T) => [U | undefined, U | undefined] = (rowA, rowB) => [
    selector(rowA),
    selector(rowB),
  ],
  subjectProperty?: ToolkitProperty | undefined,
): {
  sortingFn: ReactTableSortingFn<T> | undefined;
  enableSorting: boolean;
} {
  let sortingFn: ReactTableSortingFn<T> | undefined;

  if (isFunction(sortBy)) {
    sortingFn = (rowA, rowB) => {
      try {
        const pinnedRowSort = getPinnedRowSortingOrder<T>(
          rowA,
          rowB,
          isSortedDesc,
          shouldPinFirstRow,
        );
        if (pinnedRowSort !== 0) {
          return pinnedRowSort;
        }

        const [a, b] = getCompareValues(rowA.original, rowB.original);

        if (!isDefined(a)) {
          return 1;
        }
        if (!isDefined(b)) {
          return -1;
        }

        return sortBy(a, b, subjectProperty);
      } catch (error) {
        console.error('Error sorting column: ', error);
      }
      return 0;
    };
  }

  return {
    sortingFn,
    enableSorting: isDefined(sortBy),
  };
}
